module.exports = __webpack_public_path__ + "static/img/icon_swiper_znjc_tab.fdcff25.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swiper_znjc_tab.png
// module id = do+Y
// module chunks = 1